import { FC } from 'react';

import { IIconGlassProps } from './types';

const GlassImage = require('./glass.png');

export const IconGlass: FC<IIconGlassProps> = props => {
  const { className } = props;

  return <img alt="Узнать больше" className={className} src={GlassImage} />;
};

IconGlass.displayName = 'IconGlass';
